var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.295898,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#0058D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_361_17857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1032 5.86098L6.99471 9.96944L5.27435 8.24909",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_361_17857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.38462,
    height: 7.38462,
    fill: "white",
    transform: "translate(4.30664 4.60254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkIcon);
export default __webpack_public_path__ + "static/media/mark-icon.725f9fb2eeb29a2b7cb8de080b2d7617.svg";
export { ForwardRef as ReactComponent };